import * as Intro from 'src/styles/views/intro'

export const PriceNotice = () => {
  return (
    <Intro.PriceNoticeWrap>
      <span className="price">월 1,650원</span>에 <span className="bracket">(부가세포함)</span>
      <br />이 모든 혜택을 누려보세요.
    </Intro.PriceNoticeWrap>
  )
}
